const errorMessage = (error) => {
  try {
    return error.response?.data?.message || error.message
  } catch {
    return 'Generic Error'
  }
}

const location = () => {
  return window.location.pathname.split('/')
}

export const uiHelper = {
  errorMessage,
  location
}
